module.exports = __webpack_public_path__ + "static/media/2.59b8677f.jpg";